import React from 'react';

import ProductStore from 'stores/ProductStore';
import SubmitSubProductForm from 'views/designer/SubmitSubProductForm';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import {Container} from 'flux/utils';
import HttpService from 'service/HttpService';


class AddSubProductPage extends React.Component {
    static getStores() {
		return [ProductStore];
	}

	static calculateState(prevState, props) {
		const productId = props.match.params.productId;
		
		const product = ProductStore.getProduct(productId);

		const newState = {
				product: product,
			};
		return newState;
    }
    
    componentDidMount() {
        const productId = this.props.match.params.productId;

        const product = this.state.product;

		if(product === null)
			HttpService.getProduct(productId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
		const product = this.state.product;

		const productChanged = prevProps.productId !== this.props.productId;
		if(product === null) {
			//check if new product link is clicked or not
			if(productChanged === true)
				HttpService.getProduct(this.props.productId);
		}
	}

	render() {
		const product = this.state.product;

		return (
				<SetoCanvasPage id="submitDesignPage" title="Submit your Design and Start Earning From Home | Seto Canvas"
								metaDescription="Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more.">
					
				{product && 
                <SubmitSubProductForm product={product} />}
				</SetoCanvasPage>
			);
		
	}
}

export default Container.create(AddSubProductPage, {withProps: true});


// WEBPACK FOOTER //
// ./src/pages/products/AddSubProductPage.js